import { React } from 'react';
import ChatLayout from '../../components/Chat/index.jsx';

const Chat = () => {
  return <ChatLayout />;
};

export default Chat;
